@if (column.type === ColumnType.DATE_TIME) {
  <td>{{ ObjectUtils.getProp(data, column.field) | ipSharedFormatDateTime | ipSharedEmpty }}</td>
} @else if (column.type === ColumnType.DATE) {
  <td>{{ ObjectUtils.getProp(data, column.field) | ipSharedFormatDate | ipSharedEmpty }}</td>
} @else if (column.type === ColumnType.BOOLEAN) {
  <td>{{ ObjectUtils.getProp(data, column.field) ? '✓' : '-' }}</td>
} @else if (column.type === ColumnType.ACTIONS){
  <td><ng-content></ng-content></td>
} @else {
  <td>{{ ObjectUtils.getProp(data, column.field, translate) | ipSharedEmpty }}</td>
}
